import React, { useState, useRef, useEffect, useCallback } from "react";
import Draggable from "react-draggable";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants,
  slide_bounce_variants
} from "shared/components/animations";
import Socket from "socket";
import CardOptionBox from "../components/CardOptionBox";
import drawImg from "assets/images/och/draw.png";
import passImg from "assets/images/och/pass.png";
import arrowLeft from "assets/images/och/left-arrow.png";
import check from "assets/images/och/check.png";
import deny from "assets/images/och/deny.png";
import arrowRight from "assets/images/och/right-arrow.png";

const ActivePlayerPlaying = ({
  roomId,
  ActiveCard,
  currentPlayerCard,
  handleButtonClick = () => {},
  crazySuit,
  play_card,
  play_eight,
  your_turn,
  DrawDeck
}) => {
  const isDraggingRef = useRef(false);
  const draggedItemIdRef = useRef(null);
  const draggableRefs = useRef({});
  const [isplayerCardValid, setIsPlayerCardValid] = useState("null");
  const [crazySuitCard, setCrazySuitCard] = useState(null);
  const [currentRotate, setCurrentRotate] = useState(0);
  const [expandedCard, setExpandedCard] = useState({
    cardInfo: "",
    index: ""
  });

  if (crazySuit) {
    ActiveCard.suit = crazySuit;
  }
  const CardLength = currentPlayerCard?.player_hand.length || null;

  const handleTouch = (data,index) => {
    if (index >= CardLength) {
      setExpandedCard({
        cardInfo: data,
        index: CardLength - 1
      });
     
    } else if (index < 0) {
      setExpandedCard({
        cardInfo: data,
        index: 0
      });
    
    } else {
      setExpandedCard({
        cardInfo: data,
        index: index
      });
    
    }
    if (
      data?.suit === ActiveCard?.suit ||
      data?.number === 8 ||
      data?.number === ActiveCard?.number
    ) {
      setIsPlayerCardValid(true);
    } else {
      setIsPlayerCardValid(false);
    }
  };

  const onDragStart = (e, data) => {



    const imageId = data.node.querySelector("img").getAttribute("id");
    const nodeId = imageId;
    isDraggingRef.current = true;
    draggedItemIdRef.current = nodeId;
  };

  const onStop = () => {
    if (!isDraggingRef.current) {
      setCurrentRotate(currentRotate + 90);
    }
    isDraggingRef.current = false;
    const dropTarget = document.querySelector(".image");
    const dropRect = dropTarget.getBoundingClientRect();
    const dragElement = document.querySelector(
      `img[id='${draggedItemIdRef.current}']`
    );
    if (dragElement) {
      const dragRect = dragElement.getBoundingClientRect();

      if (
        dragRect.x + dragRect.width >= dropRect.x &&
        dragRect.x <= dropRect.x + dropRect.width &&
        dragRect.y + dragRect.height >= dropRect.y &&
        dragRect.y <= dropRect.y + dropRect.height
      ) {
        handleCardClick();
      } else {
        const dragRef = draggableRefs.current[draggedItemIdRef.current];
        if (dragRef) {
          dragRef.setState({ x: 0, y: 0 });
        }
      }
    }
  };

  const playActiveCard = () => {
 if(isplayerCardValid){
    if (expandedCard?.cardInfo?.number == 8) {
      play_eight();

      setCrazySuitCard("suit");

    } else {
      play_card();
      const data = {
        action: "play-card-och",
        roomId,
        playerId: currentPlayerCard?.player_id,
        number: expandedCard?.cardInfo?.number,
        suit: expandedCard?.cardInfo?.suit
      };

      Socket.sendMessage(data);
    }}

  };

  const chooseSuit = (crazySuit) => {
    const data = {
      action: "play-card-och",
      roomId,
      playerId: currentPlayerCard?.player_id,
      number: expandedCard?.cardInfo?.number,
      suit: expandedCard?.cardInfo?.suit,
      crazySuit
    };

    Socket.sendMessage(data);
    setCrazySuitCard(null);
  };
  const handleCardClick = useCallback(
    _.debounce(() => playActiveCard(), 1000, {
      leading: true,
      trailing: false
    }),
    [expandedCard]
  );
  const handleClosecrazySuit = () => {
    const dragRef = draggableRefs?.current[draggedItemIdRef.current] || {};
    setCrazySuitCard(null);
    dragRef.setState({ x: 0, y: 0 });
  };
  const handle_card_validation = () => {
    setIsPlayerCardValid("");
  };

  useEffect(() => {
    return Socket.addListener("play-card-och", handle_card_validation());
  }, []);

  useEffect(() => {
    const dropTarget = document.querySelector(".image");
    if (dropTarget) {
      dropTarget.addEventListener("mouseup", onStop);
    }
    return () => {
      if (dropTarget) {
        dropTarget.removeEventListener("mouseup", onStop);
      }
    };
  }, []);

  useEffect(()=>{
    your_turn();
  },[])

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <div className="och-playing">
        <div>
          <motion.h2 variants={fadeVariants} className="title">
            Your turn!
          </motion.h2>
          <motion.p variants={fadeVariants} className="sub-title">
            Active Card
          </motion.p>
          <motion.div variants={staticBounceVariants} className="active-card">
            <div className="image">
              <img src={ActiveCard?.url} className="img-fluid" alt="" />
            </div>
            {isplayerCardValid === true && (
              <div className="correct">
                <img src={check} className="img-fluid check" alt="" />
              </div>
            )}
            {isplayerCardValid === false && (
              <div className="wrong">
                <img src={deny} className="img-fluid check" alt="" />
              </div>
            )}
          </motion.div>
        </div>
        <motion.div variants={staticBounceVariants} className="card-outer">
          {currentPlayerCard?.player_hand?.map((item, index) => (
            <Draggable
              key={index}
              onStart={onDragStart}
              onStop={onStop}
              data-id={index}
              ref={(ref) => (draggableRefs.current[index] = ref)}
         
              position={{ x: 0, y: 0 }}
            >
              <div
                className={`cards-inner ${
                  expandedCard?.index === index ? "expanded" : ""
                } ${index === CardLength - 1 ? "right-card-move" : ""}   ${
                  index === 0 ? "left-card-move" : ""
                }  `}
                style={{
                  marginTop:
                    index < CardLength / 2
                      ? `-${((index + 1) * CardLength)/2 }px`
                      : `-${(CardLength )/2 * (CardLength - index)}px`,
                  marginLeft: `-${CardLength * 1.5}px`
                }}
              
                onTouchStart={() => handleTouch(item,index)}
              >
                <img
                  src={item?.url}
                  id={index}
                  className="img-fluid card-img"
                  alt=""
                />
              </div>
            </Draggable>
          ))}
        </motion.div>
         
        {crazySuitCard ? (
          <CardOptionBox
            chooseSuit={chooseSuit}
            onClose={handleClosecrazySuit}
          />
        ) : _.isEmpty(DrawDeck) ? (
          <motion.div variants={slide_bounce_variants} className="draw-pass">
            <img
              src={passImg}
              onClick={() => handleButtonClick("pass")}
              className="img-fluid"
              alt="draw"
            />
          </motion.div>
        ) : (
          <motion.div variants={slide_bounce_variants} className="draw-pass">
            <img
              src={drawImg}
              onClick={() => handleButtonClick("draw")}
              className="img-fluid"
              alt="draw"
            />
          </motion.div>
        )}
      </div>
      <div className="arrow-left">
        <img
          src={arrowLeft}
          className="img-fluid"
          alt=""
       
          onTouchStart={() =>
            handleTouch( currentPlayerCard?.player_hand[expandedCard.index - 1],
              expandedCard.index - 1)
          }
        />
      </div>
      <div className="arrow-right">
        <img
          src={arrowRight}
          className="img-fluid"
          alt=""
      
          onTouchStart={() =>
            handleTouch(currentPlayerCard?.player_hand[expandedCard.index + 1], expandedCard.index + 1)
          }
        />
      </div>
    </motion.div>
  );
};

export default ActivePlayerPlaying;
